import { MAIN_QUESTS_GROUP } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const OverknightsDailyQuests: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Login to OverKnights",
    caption: "",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-daily-login-completed",
    ruleId: "daily-login",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 28,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Play 1 Duel",
    caption: "Learn how to earn more points",
    increase: 25,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-daily-duel-completed",
    ruleId: "daily-duel",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 28,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 1 Duel",
    caption: "Learn how to earn more points",
    increase: 50,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-1-duel-completed",
    ruleId: "win-1-duel",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 28,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 5 Duels",
    caption: "Learn how to earn more points",
    increase: 300,
    secondaryIncrease: 7,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-5-duel-completed",
    ruleId: "win-5-duel",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 28,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 10 Duels",
    caption: "Learn how to earn more points",
    increase: 600,
    secondaryIncrease: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-10-duel-completed",
    ruleId: "win-10-duel",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 28,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
];

const OverknightsWeeklyQuests: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 100 Duels",
    caption: "Learn how to earn more points",
    increase: 2000,
    secondaryIncrease: 60,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-100-duel-completed",
    ruleId: "win-100-duel",
    recurring: true,
    endDate: new Date("2025-06-13T18:00:00Z"),
    maxCompletionCount: 4,
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
];

const OverknightsOneTimeQuests: Quest[] = [
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/OverKnightsGame",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-twitter-follow-completed",
    ruleId: "twitter-follow",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.gg/nZy2cNewjq",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-discord-follow-completed",
    ruleId: "discord-follow",
  },
  {
    type: "link",
    key: "x-like-and-retweet-validation",
    icon: "X",
    label: "Like and Retweet Post on X",
    caption: "Extra Gems for sharing on X",
    increase: 40,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "233a023c-b8ff-4cd6-b1eb-fc4986e66864-overknights-like-retweet-1-completed",
    ruleId: "overknights-like-retweet-1",
    // tweetText: "OverKnights LIVE on @Immutable Play ⚔ The wait is over. The cards are ready. And the arena is open. Sign up, Complete Quests, Earn Gems and join the Closed Alpha on Epic Games.",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Play your first Duel",
    caption: "Learn how to earn more points",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-play-first-duel-completed",
    ruleId: "play-first-duel",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Create a Loadout",
    caption: "Learn how to earn more points",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-create-loadout-completed",
    ruleId: "create-loadout",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Customize a Command Card",
    caption: "Learn how to earn more points",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "233a023c-b8ff-4cd6-b1eb-fc4986e66864-customize-command-card-completed",
    ruleId: "customize-command-card",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 50 Duels",
    caption: "Learn how to earn more points",
    increase: 1000,
    secondaryIncrease: 150,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-50-duels-completed",
    ruleId: "win-50-duels",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 250 Duels",
    caption: "Learn how to earn more points",
    increase: 2500,
    secondaryIncrease: 150,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    ruleId: "win-250-duels",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-250-duels-completed",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 500 Duels",
    caption: "Learn how to earn more points",
    increase: 4000,
    secondaryIncrease: 150,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    ruleId: "win-500-duels",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-500-duels-completed",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ESports",
    label: "Win 1000 Duels",
    caption: "Learn how to earn more points",
    increase: 10000,
    secondaryIncrease: 600,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-win-1000-duel-completed",
    ruleId: "win-1000-duel",
    linkUrl: "https://store.epicgames.com/en-US/p/overknights-6e332e",
  },
];

export const socialSharingTweetA =
  "Who would you trust to pilot your OverKnight in a high-stakes duel? (Tag a friend or shout out a worthy Pilot)";
export const socialSharingTweetB =
  "How did your OverKnight look in your strongest loadout? Share your winning Part & Card combo.";

const OverknightsPromoQuests: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X and tag your friend",
    caption: "Extra Gems for sharing on X",
    linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetA)}`,
    increase: 1000,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-tweet-1-completed",
    ruleId: "tweet-1",
    tweetUsername: "@OverKnightsGame",
    tweetText: "@OverKnightsGame",
    tweetCaption: socialSharingTweetA,
  },
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X and share your loadout",
    caption: "Extra Gems for sharing on X",
    linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetB)}`,
    increase: 1000,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "233a023c-b8ff-4cd6-b1eb-fc4986e66864-tweet-2-completed",
    ruleId: "tweet-2",
    tweetUsername: "@OverKnightsGame",
    tweetText: "@OverKnightsGame",
    tweetCaption: socialSharingTweetB,
  },
];
export const OverknightsPointsQuests: QuestGroup[] = [
  {
    key: "promo",
    header: {
      image: "",
      description: "",
      title: "Boost your points",
    },
    totalGemsGranted: 0,
    quests: OverknightsPromoQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "one-time",
    header: {
      image: "",
      description: "",
      title: "One-time",
    },
    totalGemsGranted: 0,
    quests: OverknightsOneTimeQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "daily",
    header: {
      image: "",
      description: "",
      title: "Daily",
    },
    totalGemsGranted: 0,
    quests: OverknightsDailyQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "weekly",
    header: {
      image: "",
      description: "",
      title: "Weekly",
    },
    totalGemsGranted: 0,
    quests: OverknightsWeeklyQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
